import { ArrowUpRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL } from "@/lib/site";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

const FEATURES = [
  "Stove",
  "Refrigerator",
  "Microwave",
  "Coffee Maker",
  "Television",
  "Private Bathroom",
  "Select Dishes and Utensils",
  "Wi-Fi",
  "Cable Television",
] as const;

export function MotelSection() {
  const photo = PHOTOS.parkModelCarport;

  return (
    <section
      id="motel-rooms"
      className="scroll-mt-28 bg-surface py-24 sm:py-28 lg:py-32"
      aria-labelledby="motel-title"
    >
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-4 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:gap-20 lg:px-10">
        <div>
          <Reveal>
            <p className="eyebrow text-clay">Comfort Without an RV</p>
            <h2
              id="motel-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Motel Rooms and Furnished Efficiency Options
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Guests traveling without an RV can stay in one of Amigo Inn&apos;s motel or
              efficiency-style accommodations. These practical furnished options are well suited for
              fishing trips, work assignments, weekend visits, and longer stays in Zapata.
            </p>
          </Reveal>

          <Reveal delay={0.08} className="mt-8">
            <p className="text-sm font-semibold text-forest-deep">
              Available conveniences may include:
            </p>
            <ul className="mt-4 grid gap-x-6 sm:grid-cols-2">
              {FEATURES.map((feature) => (
                <li
                  key={feature}
                  className="flex items-center gap-3 border-b border-sand/70 py-3 text-sm text-muted-foreground"
                >
                  <Check className="size-4 shrink-0 text-forest" aria-hidden="true" />
                  {feature}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.14} className="mt-8">
            <Button asChild variant="book" size="cta">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                Check Room Availability <ArrowUpRight aria-hidden="true" />
              </a>
            </Button>
          </Reveal>
        </div>

        <MaskReveal className="media-zoom rounded-sm">
          <img
            src={photo.src}
            srcSet={photo.srcSet}
            sizes={PHOTO_SIZES.half}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading="lazy"
            decoding="async"
            className="aspect-[5/4] w-full rounded-sm object-cover"
          />
        </MaskReveal>
      </div>
    </section>
  );
}
